import { concreteGarageId } from './concreteGarageId';

export function resolveActiveBranchDisplay({
  activeGarageId,
  user,
  branches = [],
  multiBranch = false,
  language = 'en',
  t = (k) => k,
}) {
  const isAr = language?.startsWith('ar');
  const genericLogo = '/assets/logo-icon.png';

  // Single-branch tenant: render exactly what it renders today
  if (!multiBranch || (Array.isArray(branches) && branches.length <= 1)) {
    const todayName = isAr
      ? user?.garage?.name_ar || user?.garage?.name
      : user?.garage?.name;
    const todayLogo = user?.garage?.logo_url || genericLogo;
    return {
      name: todayName,
      logo: todayLogo,
      isAll: false,
    };
  }

  // Multi-branch in All mode
  if (activeGarageId === 'all') {
    const allBranchesLabel = t('mb.allBranches');
    const companyName = isAr
      ? user?.company?.name_ar || user?.company?.name
      : user?.company?.name;
    const name = companyName ? `${allBranchesLabel} — ${companyName}` : allBranchesLabel;
    return {
      name,
      logo: genericLogo,
      isAll: true,
    };
  }

  // Multi-branch with a specific active branch
  const concreteId = concreteGarageId(activeGarageId, user);
  const activeBranch =
    (Array.isArray(branches) && branches.find((b) => String(b.id) === String(concreteId))) ||
    (Array.isArray(branches) && branches.find((b) => String(b.id) === String(activeGarageId))) ||
    user?.garage;

  const branchName = isAr
    ? activeBranch?.name_ar || activeBranch?.name
    : activeBranch?.name;
  const branchLogo = activeBranch?.logo_url || user?.garage?.logo_url || genericLogo;

  return {
    name: branchName,
    logo: branchLogo,
    isAll: false,
  };
}
